import { connect } from 'react-redux';
import * as SelectedCategoriesActions from '../../redux/actions/selectedCategoriesActions';

export default (WrappedComponent) => connect(null, SelectedCategoriesActions)(WrappedComponent);
